import { includes } from 'lodash';

const customMetricsChanged = () => {
  const customMetricsUpdated = document.querySelector(
    'input[name="custom_metrics_updated"]'
  )?.value;

  return includes([ 'true', true, 1, '1' ], customMetricsUpdated);
};

export { customMetricsChanged };
